import { HRIAClient } from '../client';

export interface DonationListParams {
  page?: number;
  limit?: number;
  status?: string;
  donationType?: string;
  startDate?: string;
  endDate?: string;
  minAmount?: number;
  maxAmount?: number;
  donorId?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export class DonationsAPI {
  constructor(private client: HRIAClient) {}

  list(params: DonationListParams = {}) {
    return this.client.get<{ donations: any[]; pagination: any }>('/api/v1/donations', params);
  }

  get(id: string) {
    return this.client.get<{ donation: any }>(`/api/v1/donations/${id}`);
  }

  create(payload: any) {
    return this.client.post<{ donation: any }>('/api/v1/donations', payload);
  }

  confirm(id: string, payload: { printerName?: string }) {
    return this.client.post<{ donation: any }>(`/api/v1/donations/${id}/confirm`, payload);
  }

  fail(id: string, payload: { reason?: string }) {
    return this.client.post<{ donation: any }>(`/api/v1/donations/${id}/fail`, payload);
  }

  update(id: string, payload: any) {
    return this.client.put<{ donation: any }>(`/api/v1/donations/${id}`, payload);
  }

  search(query: string) {
    return this.client.get('/api/v1/donations/search', { query });
  }

  stats(params: { startDate?: string; endDate?: string; officeId?: string } = {}) {
    return this.client.get('/api/v1/donations/stats', params);
  }

  // Fetch dynamic donation types
  types() {
    return this.client.get<{ types: string[] }>('/api/v1/donations/types');
  }
}

export const createDonationsAPI = (client: HRIAClient) => new DonationsAPI(client);
